module.exports = __webpack_public_path__ + "static/detail-bg.c1809ec6.png";